// extracted by mini-css-extract-plugin
export var marginNegative = "_7k-5 _7k-3 _7k-1";
export var marginPositive = "_7k-4 _7k-3 _7k-1";
export var modalContent = "_7k-6";
export var samplesTable = "_7k-8";
export var samplesTableContainer = "_7k-7";
export var statBox = "_7k-a";
export var tableCell = "_7k-1";
export var tableCellCenter = "_7k-2 _7k-1";
export var tableCellRight = "_7k-3 _7k-1";
export var tableHeader = "_7k-0";
export var trackingNumber = "_7k-9";